import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import AskQuestionListItem from './AskQuestionListItem';

/**
 * AskQuestionPanel — 提问答疑面板
 *
 * 显示当前页面上下文（讨论/文章）下的所有提问。
 * 支持 tab 切换：全部提问 / 我的提问。
 */
export default class AskQuestionPanel extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.activeTab = 'all'; // 'all' | 'mine'
    this.questions = [];
    this.loading = false;
    this.error = null;
    this.targetType = this.attrs.targetType; // 'discussion' | 'article'
    this.targetId = this.attrs.targetId;
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    this.fetchQuestions();
  }

  api(path) {
    return app.forum.attribute('apiUrl') + path;
  }

  fetchQuestions() {
    if (!this.targetType || !this.targetId) return;

    this.loading = true;
    this.error = null;
    m.redraw();

    const params = {
      targetType: this.targetType,
      targetId: this.targetId,
    };

    if (this.activeTab === 'mine') {
      params.userId = 'me';
    }

    app
      .request({
        url: this.api('/taro/ask-questions/context'),
        method: 'GET',
        params,
      })
      .then((data) => {
        this.loading = false;
        // 用 app.store.push 解析 JSON:API → Flarum model
        this.questions = data.data ? app.store.pushPayload(data) : [];
        m.redraw();
      })
      .catch((err) => {
        this.loading = false;
        this.error = err.statusText || '加载失败';
        m.redraw();
      });
  }

  switchTab(tab) {
    if (tab === this.activeTab) return;
    this.activeTab = tab;
    this.fetchQuestions();
  }

  get isUserLoggedIn() {
    return !!app.session.user;
  }

  view() {
    return (
      <div className="AskQuestionPanel">
        {/* Header */}
        <div className="AskQuestionPanel-header">
          <div className="AskQuestionPanel-headerTitle">
            <i className="fas fa-question-circle"></i>
            {' '}提问答疑
            <span className="AskQuestionPanel-headerCount">
              {this.loading ? '' : ` (${this.questions.length})`}
            </span>
          </div>
          <button
            className="Button Button--icon AskQuestionPanel-closeBtn"
            onclick={() => this.attrs.onclose()}
            title="关闭"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Tabs */}
        <div className="AskQuestionPanel-tabs">
          <button
            className={'AskQuestionPanel-tab' + (this.activeTab === 'all' ? ' AskQuestionPanel-tab--active' : '')}
            onclick={() => this.switchTab('all')}
          >
            全部提问
          </button>
          {this.isUserLoggedIn && (
            <button
              className={'AskQuestionPanel-tab' + (this.activeTab === 'mine' ? ' AskQuestionPanel-tab--active' : '')}
              onclick={() => this.switchTab('mine')}
            >
              我的提问
            </button>
          )}
        </div>

        {/* Content */}
        <div className="AskQuestionPanel-body">
          {this.loading && (
            <div className="AskQuestionPanel-loading">
              <LoadingIndicator />
              <div className="AskQuestionPanel-loadingText">加载中…</div>
            </div>
          )}

          {this.error && (
            <div className="AskQuestionPanel-error">
              <i className="fas fa-exclamation-triangle"></i> {this.error}
            </div>
          )}

          {!this.loading && !this.error && this.questions.length === 0 && (
            <div className="AskQuestionPanel-empty">
              <i className="fas fa-inbox"></i>
              <p>{this.activeTab === 'mine' ? '你还没有在这个页面提过问' : '当前页面还没有提问'}</p>
            </div>
          )}

          {!this.loading && !this.error && this.questions.length > 0 && (
            <div className="AskQuestionPanel-list">
              {this.questions.map((q, i) => (
                <AskQuestionListItem
                  key={q.id || i}
                  question={q}
                  targetType={this.targetType}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}
